import { useContext, useState, useEffect } from 'react';
import PageContext from "./PageContext";
import { createTheme, TextField, ThemeProvider, Typography } from '@mui/material';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent';

const theme = createTheme({
    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight:'24px'
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiInputBase-input": {
              fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
              fontSize: "16px",
              fontWeight: "400",
              color:"gray"
            },
          },
        },
      },
    },
  });


const ProcessingCommentModal = () =>{
    // get context from parent
    const {
        showProcessingCommentModal, 
        setShowProcessingCommentModal,
        processingRow,
        setProcessingRow, 
    } = useContext(PageContext);


    return(
        <> 
            <ThemeProvider theme={theme}>
                <CCOffcanvas
                    title={`Processing Comment for ${processingRow['filename']}`}
                    show={showProcessingCommentModal}
                    onCanvasClose={()=>setShowProcessingCommentModal(showProcessingCommentModal => showProcessingCommentModal = false)}
                    bodyCssClassName="offcanvas-body bg-white p-3"
                    offCanvasClassName='offcanvas-parent-card-30'
                    >
                    <div className="d-flex flex-column h-100">
                      <div className='mb-2'>
                          <Typography>
                              Excel Upload Comment
                          </Typography>
                      </div>
                      <div className="d-flex flex-column flex-grow-1 overflow-scroll" style={{maxHeight:"88%",overflow:"overlay",fontSize:"14px"}}>
                          <TextField 
                              sx={{background:"#FFFFFE"}}
                              size='small' fullWidth multiline  variant="outlined" 
                              value={processingRow['processingcomment']} inputProps={{readOnly: true}}/>
                      </div>
                      <div
                          className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                      >
                          <ButtonComponent onButtonClick={()=>setShowProcessingCommentModal(showProcessingCommentModal => showProcessingCommentModal = false)} tag='OK' 
                              border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}/>
                      </div>
                    </div>
                </CCOffcanvas>
            </ThemeProvider>
        </>
    );
}

export default ProcessingCommentModal;